<template>
  <el-dialog title="客户意见调查表" :close-on-click-modal="false" :append-to-body="true" center :visible.sync="visible" width="945px">
    <div class="info_main">
      <div class="info_title">
        <h3>尊敬的客户：</h3>
        <p>为了提高分析测试中心的服务质量，请您对本中心各方面工作进行评价，并提出宝贵意见和建议，以便今后能为您提供更加满意的服务，请予反馈，感谢您的配合！</p>
      </div>
      <div class="info_content">
        <table class="oldTable">
          <tr>
            <th width="160">调查项目</th>
            <th colspan="4">满意度</th>
            <th width="110" align="center">评分</th>
          </tr>
          <tr>
            <td>客户沟通的充分性</td>
            <td><el-radio v-model="infoObj.communication" label="非常满意">非常满意</el-radio></td>
            <td><el-radio v-model="infoObj.communication" label="比较满意">比较满意</el-radio></td>
            <td><el-radio v-model="infoObj.communication" label="一般">一般</el-radio></td>
            <td><el-radio v-model="infoObj.communication" label="不满意">不满意</el-radio></td>
            <td>
              <el-input
                type="number"
                class="mo-input--number"
                max="25"
                v-model.number="infoObj.communicationScore"
                @input="
                  if (infoObj.communicationScore <= 0) infoObj.communicationScore = 0;
                  if (infoObj.communicationScore >= 25) infoObj.communicationScore = 25;
                "
                placeholder="单项25分"
              ></el-input>
            </td>
          </tr>
          <tr>
            <td>工作流程得规范性</td>
            <td><el-radio v-model="infoObj.process" label="非常满意">非常满意</el-radio></td>
            <td><el-radio v-model="infoObj.process" label="比较满意">比较满意</el-radio></td>
            <td><el-radio v-model="infoObj.process" label="一般">一般</el-radio></td>
            <td><el-radio v-model="infoObj.process" label="不满意">不满意</el-radio></td>
            <td>
              <el-input
                type="number"
                class="mo-input--number"
                max="25"
                v-model.number="infoObj.processScore"
                @input="
                  if (infoObj.processScore <= 0) infoObj.processScore = 0;
                  if (infoObj.processScore >= 25) infoObj.processScore = 25;
                "
                placeholder="单项25分"
              ></el-input>
            </td>
          </tr>
          <tr>
            <td>数据结果的及时性</td>
            <td><el-radio v-model="infoObj.result" label="非常满意">非常满意</el-radio></td>
            <td><el-radio v-model="infoObj.result" label="比较满意">比较满意</el-radio></td>
            <td><el-radio v-model="infoObj.result" label="一般">一般</el-radio></td>
            <td><el-radio v-model="infoObj.result" label="不满意">不满意</el-radio></td>
            <td align="cneter">
              <el-input
                type="number"
                class="mo-input--number"
                max="25"
                v-model.number="infoObj.resultScore"
                @input="
                  if (infoObj.resultScore <= 0) infoObj.resultScore = 0;
                  if (infoObj.resultScore >= 25) infoObj.resultScore = 25;
                "
                placeholder="单项25分"
              ></el-input>
            </td>
          </tr>
          <tr>
            <td>检测报告的正确性</td>
            <td><el-radio v-model="infoObj.report" label="非常满意">非常满意</el-radio></td>
            <td><el-radio v-model="infoObj.report" label="比较满意">比较满意</el-radio></td>
            <td><el-radio v-model="infoObj.report" label="一般">一般</el-radio></td>
            <td><el-radio v-model="infoObj.report" label="不满意">不满意</el-radio></td>
            <td>
              <el-input
                type="number"
                class="mo-input--number"
                max="25"
                v-model.number="infoObj.reportScore"
                @input="
                  if (infoObj.reportScore <= 0) infoObj.reportScore = 0;
                  if (infoObj.reportScore >= 25) infoObj.reportScore = 25;
                "
                placeholder="单项25分"
              ></el-input>
            </td>
          </tr>
          <tr>
            <td height="80">意见和建议</td>
            <td colspan="5" style="text-align: left; padding: 0">
              <el-input v-model="infoObj.opinions" type="textarea" rows="3" resize="none" placeholder="" style="border: none"></el-input>
            </td>
          </tr>

          <tr>
            <td colspan="6" height="50" style="text-align: left; padding-left: 10px">
              <span> 总体服务评价：</span>
              <el-radio v-model="infoObj.summary" label="满意">满意</el-radio>
              <el-radio v-model="infoObj.summary" label="不满意">不满意</el-radio>
            </td>
          </tr>
        </table>
      </div>
      <div class="btnbox">
        <el-button size="small" round @click="visible = false">取消</el-button>
        <el-button type="primary" size="small" round @click="submitHandle()">提交</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      id: "",
      infoObj: {
        communication: "非常满意",
        communicationScore: "25",
        process: "非常满意",
        processScore: "25",
        result: "非常满意",
        resultScore: "25",
        report: "非常满意",
        reportScore: "25",
        opinions: "",
        summary: "满意",
      },
    };
  },
  computed: {
    visible: {
      get() {
        return this.$store.state.surveyVisible;
      },
      set(val) {
        this.$store.commit("updateSurveyVisible", val);
      },
    },
  },

  methods: {
    submitHandle() {
      let params = {
        ...this.infoObj,
      };
      if(params.communicationScore === '' || params.processScore === '' || params.reportScore === '' || params.resultScore === ''){
        return this.$message.warning('请输入评分！')
      }
      this.$http.post(this.$api.systemApi.qsaAdd, params).then(() => {
        this.$message({
          message: "感谢您的评价！",
          type: "success",
          duration: 1500,
          onClose: () => {
            this.visible = false;
          },
        });
      });
    },
  },
};
</script>
<style lang="scss">
.oldTable {
  input {
    border: none;
  }
  textarea {
    border: none;
  }
  .mo-input--number {
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
    input[type="number"] {
      -moz-appearance: textfield;
      line-height: normal;
      text-align: center;
    }
  }
}
</style>
<style lang="scss" scoped>
.info_main {
  .info_title {
    p {
      text-indent: 2em;
      line-height: 24px;
    }
  }
  .oldTable {
    font-size: 11px;
    color: #333333;
    border-width: 1px;
    border-color: #666666;
    border-collapse: collapse;
    width: 100%;
    th {
      border-width: 1px;
      padding: 10px 8px;
      border-style: solid;
      border-color: #e3e1e1;
      background-color: #f2f3f5;
    }
    td {
      border-width: 1px;
      padding: 10px 8px;
      text-align: center;
      border-style: solid;
      border-color: #ebebeb;
      background-color: #ffffff;
    }
  }
  .btnbox {
    margin-top: 20px;
    text-align: center;
  }
}
</style>
